import FirstLoginCategory from "./components/pages/FirstLoginCategory";
import Home from "./components/pages/Home";
import Login from "./components/pages/Login";
import SignUp from "./components/pages/SignUp";


const routes = [
    {
        path: '/sign-up',
        exact: true,
        element: <SignUp />
    },
    {
        path: '/login',
        exact: true,
        element: <Login />
    },
    {
        path: '/first-login',
        exact: true,
        element: <FirstLoginCategory />
    },
    {
        path: '/',
        exact: true,
        element: <Home />
    },

    {
        path: '*',
        exact: false,
        element: <div>404 page not found</div>
    },
]
export default routes;